import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ContestsPage from './pages/contests/ContestsPage';
import ContestPage from './pages/contests/ContestPage';
import MatchesPage from './pages/matches/MatchesPage';
import ContestUsersPage from './pages/contests/ContestUsersPage';
import ContestUserSelectionsPage from './pages/contests/ContestUserSelectionsPage';
import TeamsPage from './pages/TeamsPage';
import PagesList from './pages/PagesList';
import PageEditPage from './pages/PageEditPage';
import CompetitionsPage from './pages/competitions/CompetitionsPage';
import MatchPage from './pages/matches/MatchPage';
import CompetitionPage from './pages/competitions/CompetitionPage';

export default function Router() {
  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to='/dashboard/contests' />, index: true },
        { path: 'contests', element: <ContestsPage /> },

        { path: 'matches', element: <MatchesPage /> },
        { path: 'matches/create', element: <MatchPage /> },
        { path: 'matches/edit/:id', element: <MatchPage /> },

        { path: 'contest', element: <ContestPage /> },
        { path: 'contest-users', element: <ContestUsersPage /> },
        { path: 'contest-selections', element: <ContestUserSelectionsPage /> },

        { path: 'teams', element: <TeamsPage /> },
        { path: 'pages', element: <PagesList /> },
        { path: 'pages/edit', element: <PageEditPage /> },

        { path: 'competitions', element: <CompetitionsPage /> },
        { path: 'competitions/create', element: <CompetitionPage /> },
        { path: 'competitions/edit/:id', element: <CompetitionPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to='/dashboard/contests' />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to='/404' /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to='/404' replace />,
    },
  ]);
}
